document.addEventListener("DOMContentLoaded", () => {
  const seeMoreBtn = document.querySelector(".see-more-wrapper button");
  // 点击 展开 | 隐藏
  seeMoreBtn.addEventListener("click", () => {
    let isActive = seeMoreBtn.classList.contains("active");
    document
      .querySelectorAll(".product-compare-section .need-toggle")
      .forEach((item) => {
        if (isActive) {
          item.classList.remove("open");
        } else {
          item.classList.add("open");
        }
      });
    seeMoreBtn.classList.toggle("active");
  });
  
  // 监听滑动，同步滑动
  const specTable = document.querySelector(".product-spec-table");
  const compareTable = document.querySelector(".product-compare-table");
  let isSyncing = false;
  let animationFrameId;

  const syncScroll = (targetTable, sourceTable) => {
    if (!isSyncing) {
      isSyncing = true;
      // 取消之前的动画帧请求
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      // 请求一个新的动画帧
      animationFrameId = requestAnimationFrame(() => {
        targetTable.scrollLeft = sourceTable.scrollLeft;
        isSyncing = false;
      });
    }
  };

  specTable.addEventListener("scroll", function () {
    syncScroll(compareTable, specTable);
  });

  compareTable.addEventListener("scroll", function () {
    syncScroll(specTable, compareTable);
  });
});
